import camelCase from 'lodash/camelCase';
import each from 'lodash/each';
import get from 'lodash/get';

/**
 * Normalize a Google Places Suggestion object from this:
 *   [
 *     {
 *       long_name: 'United States',
 *       short_name: 'US',
 *       types: ['country'],
 *     },
 *     // etc.
 *   ]
 *
 * To a our standard object:
 * {
 *   line1: '123 Mulberry Lane',
 *   city: 'Brooklyn',
 *   region: {
 *     code: 'NY',
 *     name: 'New York',
 *   },
 *   postal: '11211',
 *   country: {
 *     code: 'US',
 *     name: 'United States',
 *   },
 * }
 *
 * @param {Object} googleAddress The Google place result object
 */
function normalizeGoogleAddress(googleAddress = {}) {
  const addressComponents = googleAddress.address_components;
  const addressTypesMap = addressComponents.reduce(
    (result, addressComponent) => {
      each(addressComponent.types, (type) => {
        result[camelCase(type)] = {
          longName: addressComponent.long_name,
          shortName: addressComponent.short_name,
        };
      });
      return result;
    },
    {}
  );

  const streetNumber = get(addressTypesMap, 'streetNumber.longName');
  const streetAddress = get(addressTypesMap, 'route.longName');
  const city = get(
    addressTypesMap.locality || addressTypesMap.sublocalityLevel1,
    'longName'
  );
  const region = {
    code: get(addressTypesMap, 'administrativeAreaLevel1.shortName'),
    name: get(addressTypesMap, 'administrativeAreaLevel1.longName'),
  };
  const postal = get(addressTypesMap, 'postalCode.longName');
  const country = {
    code: get(addressTypesMap, 'country.shortName'),
    name: get(addressTypesMap, 'country.longName'),
  };
  const county = get(addressTypesMap, 'administrativeAreaLevel2.longName');

  return {
    line1: [streetNumber, streetAddress].join(' '),
    city,
    county,
    region,
    postal,
    country,
  };
}

export default normalizeGoogleAddress;
